import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Tabs from '@mui/material/Tabs';
import { useColors } from "../../Context/ColorsContext"
import { MediaQuerys } from "../../styles/GlobalStyle";
import { Button, Divider } from "@mui/material";

const { mobile, tablet, desktop } = MediaQuerys;

export const AppBar = styled(MuiAppBar)(({ theme }) => {
  const { colors } = useColors();

  return {
    background: colors.navbarColor,
    color: colors.white,
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: 'rgb(61 71 82 / 20%) 0px 4px 8px',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  }
});

export const TextUser = styled(Typography)(({theme}) => {
  const { colors } = useColors();
  return {
    flexGrow: 1,
    fontSize: 16,
    color: colors.white,
    margin: '0 5px',
    fontWeight: 'bold',
    [desktop]: {
      fontSize: "0.85rem",
    },
  }
});

export const BoxModal = styled(Box)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
}));

export const ContainerContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between !important",
  alignItems: "center",
  height: "64px",
  padding: "0px 12px",
}));

export const TitleNavbar = styled("span")(() => ({
  display: "flex",
  fontSize: "18px",
}));

export const ContainerMenu = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 4,
  justifyContent: "space-between",
  "& img": {
    width: "auto",
    height: "40px"
  },
  [desktop]: {
    "& .MuiTypography-root": {
      fontSize: "1rem",
    },
  },
  [mobile]: {
    "& .MuiTypography-root": {
      display: "none",
      gap: '1rem'
    },
  },
}));

export const ContainerNotification = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));

export const ContainerIcons = styled("div")(() => ({
  // width: 'auto',
  // height: 'auto',
  [desktop]: {
    width: "30px",
    height: "30px",
  },
  [mobile]: {
    with: "20px",
    height: "20px",
  },
}));

// export const CustomBadge = styled(Badge)(() => ({
//     // fontSize: "16px",
// }))

export const SelectMenu = styled(Menu)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '10px',
    overflow: 'hidden'
  },
  '& .MuiList-root': {
    width: "400px",
    padding: 0,
  },
  [mobile]: {
    position: "absolute",

  }
}));

export const ItemMenu = styled(MenuItem)(() => ({
  [desktop]: {
    fontSize: "0.75rem ",
  },
}));

export const ItemMenuDefault = styled(MenuItem)(() => ({
  paddingTop: "0",
  '&:nth-child(3)': {
    borderBottom: '1px solid lightgray'
  },
  fontSize: "0.84rem",
  cursor: "Default",
  pointerEvents: "none",
  [mobile]: {
    fontSize: "0.75rem",
  },
}));

export const ItemNotification = styled(MenuItem)((props) => {
  return {
    fontWeight: `${props.normal ? 'normal' : "bold"}`,
    borderBottom: `${props.normal ? 'none' : "1px solid lightgray"}`,
    fontSize: "16px",
    cursor: "default",
    pointerEvents: "none",
    minHeight: 0,
    [desktop]: {
      fontSize: "16px",
    },
    [tablet]: {
      fontSize: "14px",
    },
    [mobile]: {
      fontSize: "14px",
    }
  }
})

export const MenuNotification = styled(MenuItem)(({isread}) => {
  const { colors } = useColors();
  return {
    minWidth: '400px',
    background: isread === 'false' ? '#f8fbff' : colors.white,
    ':not(:last-child)': {
      borderBottom: `1px solid ${colors.gray}`,
    }
  }
})

export const CustomTabs = styled(Tabs)(() => {
  // eslint-disable-next-line no-use-before-define
  const { colors } = useColors();
  return {
    minHeight: '30px !important',
    '&.MuiButtonBase-root-MuiTab-root .Mui-selected': {
      color: `${colors.navbarColor} !important`,
      fontWeight: 'bold',
    },
    '.Mui-selected': {
      color: `${colors.navbarColor} !important`,
      fontWeight: 'bold',
    },
    '& .MuiButtonBase-root': {
      fontSize: '14px !important',
      color: '#a5a5a5',
      minHeight: '30px !important',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: colors.navbarColor,
    },
    '& .MuiBadge-badge': {
       backgroundColor: '#b9cde6',
       color: '#728299',
    },
    '& .Mui-selected .MuiBadge-badge': {
       backgroundColor: colors.navbarColor,
       color: colors.white,
    },
    [tablet]: {
      '& .MuiButtonBase-root': {
        fontSize: '12px !important'
      },
    },
    [mobile]: {
      '& .MuiButtonBase-root': {
        fontSize: '12px !important'
      },
    }
  }
});

export const CustomBadge = styled(Badge)(() => {
  const { colors } = useColors();
  return {
    marginTop: 10,
    '.MuiBadge-badge': {
      backgroundColor: colors.navbarColor,
      top: 6
    }
  }
});

export const ResponsiveTextQr = styled('span')(() => ({
  display: 'none',
  marginLeft: 0,
  '@media (min-width: 700px)': {
    display: 'inline-block',
    marginLeft: '8px'
  }
}));

export const ResponsiveDivider = styled(Divider)(() => ({
  borderColor: 'white',
  marginLeft: '8px',
  marginRight: '8px',
  height: '30px',
  alignSelf: 'center',
  '@media (min-width: 700px)': {
    marginLeft: '16px',
    marginRight: '16px'
  }
}));

export const QrButton = styled(Button)(({ theme }) => {
  const { colors } = useColors();
  return {
    color: '#ffffff',
    backgroundColor: `color-mix(in srgb, ${colors.navbarColor} 95%, white)`,
    borderColor: `color-mix(in srgb, ${colors.navbarColor} 80%, white) !important`,
    border: '1px solid',
    borderRadius: '7px',
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'none',
    lineHeight: 1,
    padding: "0 10px",
    height: "35px",
    '&:hover': {
      backgroundColor: `color-mix(in srgb, ${colors.navbarColor} 92%, white)`,
    },
    [desktop]: {
      fontSize: '0.75rem'
    },
    '@media (max-width: 699px)': {
      minWidth: 'auto',
      border: 'none',
      backgroundColor: 'transparent',
      padding: '4px',
      '&:hover': {
        backgroundColor: 'transparent',
      }
    }
  }
});